/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The InventoryControllerDtoNftInventoryValidUpdateRequest model module.
 * @module model/InventoryControllerDtoNftInventoryValidUpdateRequest
 * @version 1.0
 */
class InventoryControllerDtoNftInventoryValidUpdateRequest {
    /**
     * Constructs a new <code>InventoryControllerDtoNftInventoryValidUpdateRequest</code>.
     * @alias module:model/InventoryControllerDtoNftInventoryValidUpdateRequest
     */
    constructor() { 
        
        InventoryControllerDtoNftInventoryValidUpdateRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>InventoryControllerDtoNftInventoryValidUpdateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InventoryControllerDtoNftInventoryValidUpdateRequest} obj Optional instance to populate.
     * @return {module:model/InventoryControllerDtoNftInventoryValidUpdateRequest} The populated <code>InventoryControllerDtoNftInventoryValidUpdateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InventoryControllerDtoNftInventoryValidUpdateRequest();

            if (data.hasOwnProperty('nftInventoryNo')) {
                obj['nftInventoryNo'] = ApiClient.convertToType(data['nftInventoryNo'], 'Number');
            }
            if (data.hasOwnProperty('valid')) {
                obj['valid'] = ApiClient.convertToType(data['valid'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>InventoryControllerDtoNftInventoryValidUpdateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>InventoryControllerDtoNftInventoryValidUpdateRequest</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} nftInventoryNo
 */
InventoryControllerDtoNftInventoryValidUpdateRequest.prototype['nftInventoryNo'] = undefined;

/**
 * @member {Boolean} valid
 */
InventoryControllerDtoNftInventoryValidUpdateRequest.prototype['valid'] = undefined;






export default InventoryControllerDtoNftInventoryValidUpdateRequest;

